export default {
    appName: "Akwa Ibom State Public Servants Portal",
    domain: process.env.NODE_ENV === 'production' ? "https://publicservants.akwaibomstate.gov.ng" : "http://127.0.0.1:8000",
    localUserKey: "tn4o6uspvirzn1qr7hqzovzpfg8g",
}
    
